export const importantResources: string[] = [
  '/images/logo.webp',
  '/images/coins.webp',
  '/images/dollar.webp',
  '/images/imgReferral.webp',

  // картинки с загрузочного экрана
  '/images/referralCups/greenCup.webp',
  '/images/referralCups/redCup.webp',
  '/images/referralCups/blueCup.webp',
  '/images/referralCups/purpleCup.webp',
  '/images/referralCups/cyanCup.webp',
  '/images/Advantages/topContent-v2.webp',
  '/images/Advantages/centerContent-v2.webp',
  '/images/Advantages/AdwantagesPassport-v2.webp',
];

export const lazyResources: string[] = [
  '/images/AvatarMask.svg',
  '/images/FinishedRays.webp',
  '/images/referralCups/redCup.webp',
  '/images/referralCups/blueCup.webp',
  '/images/referralCups/cyanCup.webp',
  '/images/referralCups/greenCup.webp',
  '/images/referralCups/purpleCup.webp',
  '/images/topPlayerPlace/topPlayerPlaceFirst.webp',
  '/images/topPlayerPlace/topPlayerPlaceSecond.webp',
  '/images/topPlayerPlace/topPlayerPlaceThird.webp',
  '/images/gameTutorial/betTicketImg.webp',
  '/images/gameTutorial/waitingTable.webp',
  '/images/gameTutorial/gameTable.webp',
  '/images/gameTutorial/gameTableAutoPick.webp',
  '/images/gameTutorial/winningTable.webp',
  '/images/gameTutorial/lamp.webp',
  '/images/gameTutorial/cupEmoji.webp',
  '/images/gameTutorial/fireEmoji.webp',
  '/images/gameTutorial/peopleEmoji.webp',
  '/images/gameTutorial/depositImg.webp',
  '/images/gameTutorial/jettonsImg.webp',
  '/images/gameTutorial/gameHistoryImg.webp',
];

// картинки из обучения
export const tutorialResourcesLanding: string[] = [
  '/images/Tutorial/luckyNumber.webp',
  '/images/Tutorial/messageCircle.webp',
  '/images/Tutorial/messageGirl-v1.webp',
  '/images/Tutorial/messageGirl.webp',
  '/images/Tutorial/messageText.webp',
  '/images/Tutorial/resultGame.webp',
  '/images/Tutorial/swipeAnimation-v2.png',
  '/images/Tutorial/tapHere.png',
  '/images/Tutorial/tickets.webp',
  '/images/Tutorial/tutorialGameTime.webp',
  '/images/Tutorial/tutorialGameWinners.webp',
  '/images/Tutorial/tutorialGirl.webp',
  '/images/Tutorial/waitingForPlayer.webp',
  '/images/Tutorial/winningNumber.webp',
];
